const types = {
  // GET SUBSCRIPTION PLAN
  GET_SUBSCRIPTION: "GET_SUBSCRIPTION",
  GET_SUBSCRIPTION_RESP: "GET_SUBSCRIPTION_RESP",
  GET_SUBSCRIPTION_CLEAR: "GET_SUBSCRIPTION_CLEAR",

  // GET TESTIMONAL DATA
  GET_TESTIMONAL: "GET_TESTIMONAL",
  GET_TESTIMONAL_RESP: "GET_TESTIMONAL_RESP",
  GET_TESTIMONAL_CLEAR: "GET_TESTIMONAL_CLEAR",

  // GET TESTIMONAL DATA
  GET_SUBSCRIPTION_DETAILS: "GET_SUBSCRIPTION_DETAILS",
  GET_SUBSCRIPTION_DETAILS_RESP: "GET_SUBSCRIPTION_DETAILS_RESP",
  GET_SUBSCRIPTION_DETAILS_CLEAR: "GET_SUBSCRIPTION_DETAILS_CLEAR",

  GET_SUBSCRIPTION_PAYMENT_DETAILS: "GET_SUBSCRIPTION_PAYMENT_DETAILS",
  GET_SUBSCRIPTION_PAYMENT_DETAILS_RESP: "GET_SUBSCRIPTION_PAYMENT_DETAILS_RESP",
  GET_SUBSCRIPTION_PAYMENT_DETAILS_CLEAR: "GET_SUBSCRIPTION_PAYMENT_DETAILS_CLEAR",

  GET_DROWNGRADE_REQUEST: "GET_DROWNGRADE_REQUEST",
  GET_DROWNGRADE_REQUEST_RESP: "GET_DROWNGRADE_REQUEST_RESP",
  GET_DROWNGRADE_REQUEST_CLEAR: "GET_DROWNGRADE_REQUEST_CLEAR",
};

export default types;
